<template>
  <div class="waterfall-status">
    <WaterfallTenderStatusChip :status="waterfallTender.status" chonky />
    <TimeAgo
      v-slot="{ timeAgo }"
      :max="60 * 60 * 1000"
      :time="waterfallTender.createdDate.toJSDate()"
      :full-date-formatter="(date: Date) => d(date, 'numericDateTime')"
    >
      <small>
        {{ t('common.startedParam', { param: timeAgo }) }}
      </small>
    </TimeAgo>
  </div>
</template>

<script lang="ts" setup>
import { UseTimeAgo as TimeAgo } from '@vueuse/components';
import type { PropType } from 'vue';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { WaterfallTender } from '@/model';

import WaterfallTenderStatusChip from '@/components/rateShop/WaterfallTenderStatusChip.vue';

const props = defineProps({
  waterfallTender: {
    type: Object as PropType<WaterfallTender>,
    required: true,
  },
});
const { waterfallTender } = toRefs(props);

const { d, t } = useI18n();
</script>

<style>
.waterfall-status {
  display: flex;
  flex-direction: column;
  gap: var(--sp-1);
  align-items: center;
}
</style>
